import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { Link } from 'react-router-dom';
import ViewIcon from '@app/assets/icons/view-campaign.svg?react';
import DotsIcon from '@app/assets/icons/menu/dot-vertical.svg?react';
import BinIcon from '@app/assets/icons/bin.svg?react';
import DuplicateIcon from '@app/assets/icons/duplicate.svg?react';
import CancelIcon from '@app/assets/icons/cancel.svg?react';
// import PreviewIcon from '@app/assets/icons/preview.svg?react';
import EditIcon from '@app/assets/icons/edit-blue.svg?react';
import { usePermissions } from '@app/contexts/PermissionContext.tsx';

export const CampaignMenu = ({
  deleteCampaign,
  cloneCampaign,
  cancelCampaign,
  continueCreating,
  status,
  campaignId,
  disabledActions,
}: {
  deleteCampaign?: () => void;
  cloneCampaign?: () => void;
  cancelCampaign?: () => void;
  continueCreating?: () => void;
  status?: string;
  campaignId?: string;
  disabledActions?: {
    deleteCampaign?: boolean;
    cancelCampaign?: boolean;
    cloneCampaign?: boolean;
  };
}) => {
  const isDraft = status?.toLowerCase() === 'draft' || status?.toLowerCase() === 'drafts';
  const {can} = usePermissions()

  return (
    <Menu>
      <MenuButton 
        className="group/user flex items-center justify-center gap-2 p-2 bg-[#F6F7FA] rounded"
        onClick={(e) => e.stopPropagation()}
      >
        <DotsIcon />
      </MenuButton>
      <MenuItems
        transition
        anchor="left start"
        className="p-2 bg-white shadow-lg mt-2 min-w-[220px] transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0 rounded-lg border file:border-base-antiFlash"
      >
        {isDraft ? (
          // Draft campaign options
          <>

            { can('createCampaigns') &&
            <MenuItem>
              <button
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full text-left"
                onClick={(e) => {
                  e.stopPropagation();
                  continueCreating?.();
                }}
              >
                <EditIcon className="[&_path]:stroke-brand-darkBlue3" /> Continue creating
              </button>
            </MenuItem>
            }
            <MenuItem>
              <button
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full text-left disabled:opacity-40 disabled:cursor-not-allowed"
                disabled={disabledActions?.cloneCampaign}
                onClick={(e) => {
                  e.stopPropagation();
                  cloneCampaign?.();
                }}
              >
                <DuplicateIcon className="[&_path]:stroke-brand-darkBlue3" /> Duplicate as draft
              </button>
            </MenuItem>
            <MenuItem>
              <button
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full text-left disabled:opacity-40 disabled:cursor-not-allowed"
                disabled={disabledActions?.deleteCampaign}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteCampaign?.();
                }}
              >
                <BinIcon className="[&_path]:stroke-system-error" /> Delete campaign
              </button>
            </MenuItem>
          </>
        ) : (
          // Non-draft campaign options
          <>
            <MenuItem>
              <Link
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full"
                to={`/campaigns/${campaignId}`}
              >
                <ViewIcon className="[&_path]:stroke-brand-darkBlue3" /> Open campaign
              </Link>
            </MenuItem>
            {/*<MenuItem>*/}
            {/*  <Link*/}
            {/*    className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full"*/}
            {/*    to={`/`}*/}
            {/*  >*/}
            {/*    <PreviewIcon className="[&_path]:stroke-brand-darkBlue3" /> Open preview*/}
            {/*  </Link>*/}
            {/*</MenuItem>*/}
            <MenuItem>
              <button
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full text-left disabled:opacity-40 disabled:cursor-not-allowed"
                disabled={disabledActions?.cloneCampaign}
                onClick={(e) => {
                  e.stopPropagation();
                  cloneCampaign?.();
                }}
              >
                <DuplicateIcon className="[&_path]:stroke-brand-darkBlue3" /> Duplicate as draft
              </button>
            </MenuItem>
            <MenuItem>
              <button
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full text-left disabled:opacity-40 disabled:cursor-not-allowed"
                disabled={disabledActions?.cancelCampaign}
                onClick={(e) => {
                  e.stopPropagation();
                  cancelCampaign?.();
                }}
              >
                <CancelIcon className="[&_path]:stroke-system-error" /> Cancel campaign
              </button>
            </MenuItem>
            <MenuItem>
              <button
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full text-left disabled:opacity-40 disabled:cursor-not-allowed"
                disabled={disabledActions?.deleteCampaign}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteCampaign?.();
                }}
              >
                <BinIcon className="[&_path]:stroke-system-error" /> Delete campaign
              </button>
            </MenuItem>
          </>
        )}
      </MenuItems>
    </Menu>
  );
};
